import * as API from '@/api';
import {getField, updateField} from 'vuex-map-fields';

function initialState () {
  return {
    list: null,
  };
}

const state = initialState ();

// getters
const getters = {
  getField,
  list: state => {
    return state.list;
  },
};

// actions
const actions = {
  async get (context, payload) {
    var response = await API.adminWidget.get (payload);
    return response;
  },

  /** Get all widgets */
  async list (context, payload) {
    var response = await API.adminWidget.list (payload);
    context.commit ('set_list', {
      widgets: response.widgets.data,
    });
    return response;
  },

  async create(context, payload) {
    var response = await API.adminWidget.create(payload);
    return response;
  },

  async update(context, payload) {
    var response = await API.adminWidget.update(payload);
    return response;
  },
};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },

  set_list (state, payload) {
    state.list = payload.widgets;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
